import { FormValidation, RJSFSchema, UiSchema } from '@rjsf/utils';
import validator from '@rjsf/validator-ajv8';
import { validateSpeedUnits } from '../../Compounds/OutsideInventoryForm/OutsideInventoryForm';
import { InventoryAsset, OutsideInventorySchema } from '../../../types';
import { revealHiddenFields, withoutShowAllBranch } from './revealHiddenFields';

type SchemaPair = OutsideInventorySchema['schema'];

const FULL_WIDTH_FIELD = { width: '100%', margin: '2rem 0', padding: '0 1rem 0 0' };

const fieldOrder = (uiSchema: UiSchema): string[] => uiSchema['ui:options']?.order || [];

const withFullWidthFields = ({ validation_schema, ui_schema }: SchemaPair): SchemaPair => {
  const widened: UiSchema = { ...ui_schema };
  fieldOrder(ui_schema)
    .filter((field) => ui_schema[field] && ui_schema[field]['ui:widget'] !== 'hidden')
    .forEach((field) => {
      widened[field] = { ...ui_schema[field], 'ui:style': FULL_WIDTH_FIELD };
    });
  return { validation_schema, ui_schema: widened };
};

export const outsideInventoryEditSchema = (
  schema: SchemaPair,
  allSchemas: OutsideInventorySchema[],
  { saved, showAll, readOnly }: { saved: InventoryAsset; showAll?: boolean; readOnly: boolean }
): SchemaPair => {
  const visible =
    readOnly || showAll
      ? revealHiddenFields(schema, allSchemas, saved as Record<string, unknown>)
      : { ...schema, validation_schema: withoutShowAllBranch(schema.validation_schema) };
  return withFullWidthFields(visible);
};

export const isValidForEdit = (schema: RJSFSchema, record: InventoryAsset): boolean =>
  validator.validateFormData(record, schema, (data, errors) =>
    validateSpeedUnits(data as unknown as Record<string, unknown>, errors as FormValidation)
  ).errors.length === 0;
